export default "__VITE_PUBLIC_ASSET__421d1dd8__"